/**
 * The tenant's outbound webhook endpoint registrations
 * (GET /tenants/me/webhook-endpoints, tenant-webhook-config.openapi.yaml).
 *
 * Read by Webhook Endpoints, which manages the list, and by the Webhook
 * Delivery Log, whose empty state says whether an endpoint is registered at
 * all: a log with no endpoint is empty because nothing can be delivered, not
 * because no job has emitted an event (fi-g4-9). One query key, so both pages
 * share one read and one invalidation.
 */

import { useQuery } from '@tanstack/react-query';
import { tenantWebhookConfigClient } from '../api/client';

export const WEBHOOK_ENDPOINTS_QUERY_KEY = ['admin', 'tenants', 'me', 'webhook-endpoints'] as const;

export function useWebhookEndpoints() {
  return useQuery({
    queryKey: WEBHOOK_ENDPOINTS_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await tenantWebhookConfigClient.GET('/tenants/me/webhook-endpoints', {
        params: { query: { page: 1, limit: 100 } },
      });
      if (error || !data) throw new Error('Failed to load webhook endpoints');
      return data;
    },
    staleTime: 15_000,
  });
}
